import { gql } from '@apollo/client';
import { ContactEmailFragment } from 'graphql/ContactEmail/fragments/ContactEmailFragment';
import { ContactPhoneFragment } from 'graphql/ContactPhone/fragments/ContactPhoneFragment';
import { CurrencyFragment } from 'graphql/Currency/fragments/CurrencyFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { LocationFragment } from 'graphql/Location/fragments/LocationFragment';
/**
 * @fragment DealContactFragment
 * @since 1.0.0
 */
export const DealContactFragment = gql `
  fragment DealContactFragment on Contact {
    id
    title
    firstname
    lastname
    fullname
    discount
    primary
    manager

    emails {
      ...ContactEmailFragment
    }

    phones {
      ...ContactPhoneFragment
    }

    primaryEmail {
      ...ContactEmailFragment
    }

    primaryPhone {
      ...ContactPhoneFragment
    }

    location {
      ...LocationFragment
    }

    client {
      id
      name
      number
      website
      isEndClient
      createdAt
      updatedAt
      currency {
        ...CurrencyFragment
      }

      locations {
        ...LocationFragment
      }

      primaryLocation {
        ...LocationFragment
      }
    }

    user {
      id
      firstname
      lastname
      fullname
      email
      title
    }

    language {
      ...LanguageFragment
    }

    image {
      id
      url
    }
  }

  ${LocationFragment}
  ${ContactEmailFragment}
  ${ContactPhoneFragment}
  ${LanguageFragment}
  ${CurrencyFragment}
`;
